import { Component, ViewContainerRef, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { VendorDropDown } from '../../models/customer/customer-model';
import { CustomerService } from '../../services/customer/customer.service';
import { ToastsManager } from 'ng2-toastr';
import { SinglePOReport } from '../../models/PurchaseOrder/purchase-order-detail-view.model';
import { SelectModule } from 'ng2-select';
@Component({
  selector: 'app-single-po-report',
  templateUrl: './single-po-report.component.html',
  styleUrls: ['./single-po-report.component.css']
})
/** SinglePoReport component*/
export class SinglePoReportComponent implements OnInit{

 

  public report: SinglePOReport[] = [];
  public customerList: VendorDropDown[];
  public VendorLiveSearch: VendorDropDown[];
  public showSuggestionsLive: boolean = false;
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  regDate: Date;
  endRegDate: Date;
  startDate: string;
  endDate: string;
  vendorName: string;
  reportFrom: string;
  reportTo: string;
  public vendorID: string;
  public VID: number;
  total: number;
  public firstLoad: boolean = true;
  searchVendorName: string = "";
  
    /** SinglePoReport ctor */
  constructor(
    private readonly purchaseOrderService: PurchaseOrderService,
    private _avRoute: ActivatedRoute, private readonly CustomerService: CustomerService, public toastr: ToastsManager, vcr: ViewContainerRef
  ) {
    this.toastr.setRootViewContainerRef(vcr);
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.endRegDate = new Date();
    this.regDate = new Date();
    this.customerList = [];
    this.vendorID = "";
    this.VID = 0;
    this.firstLoad = true;
    this.vendorName = "";
    this.reportFrom = "";
    this.reportTo = "";
    
    this.total = 0;
    this.searchVendorName = "";
  }

  public ngOnInit(): any {
    this.getVendors();
    
  }
  

  public selected(value: any): void {
  }

  public removed(value: any): void {
  }

  public typed(value: any): void {
  }





  RemoveSelected() {
    if (this.searchVendorName != "") {
      this.searchVendorName = "";
      this.vendorID = "";
      this.VID = 0;
    }


  }
  hide() {
    this.showSuggestionsLive = false;
  }
  selectStartDate(e) {
    if (e != null) {
      this.startDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.endDate = e;
      this.regDate = e;
      this.endRegDate = new Date(this.regDate);
    }
  }


  LiveSearchVendor(searchText: string) {
    var length = 0;
    
    try {
      length = searchText.length;
    } catch (e) {
      return;
    }
    if (length > 0) {
      this.VendorLiveSearch = [];
      let regexp = new RegExp(searchText.toLowerCase());
      this.VendorLiveSearch = this.customerList.filter(x => x.shopeName.toLowerCase().match(regexp))
      this.showSuggestionsLive = true;
    }
    else {
      this.VendorLiveSearch = this.customerList;
      this.showSuggestionsLive = false;
    }
  }

  SelectVendor(product: VendorDropDown) {
    this.searchVendorName = product.shopeName;
    this.vendorID = product.customerID.toString();
    this.VID = product.customerID;
    this.showSuggestionsLive = false;
  }
  focusFunction() {
    this.showSuggestionsLive = true;
  }

  focusOutFunction() {
    this.showSuggestionsLive = false;
  }
  getVendors() {
    if (this.customerList.length == 0) {
      this.CustomerService.getVendorsDropDown().subscribe(
        data => {
          this.customerList = data;
          this.VendorLiveSearch = this.customerList;
          this.firstLoad = false;
        }
      )
    }
  }
  selectionChanged(event: VendorDropDown) {
    try {
      this.vendorID = event.customerID.toString();
      this.VID = event.customerID;
    } catch (e) {

    }
    if (event === undefined) {
      this.vendorID = "";
      this.VID = 0;
    }
  }

  ShowResult() {
    if (this.VID == 0) {
      this.toastr.error("Please Select Vendor ", "Error");
      return;
    }
    if (this.startDate === undefined)
    {
      this.toastr.error("Please Select Start Date ", "Error");
      return;
    }
    if (this.endDate === undefined) {
      this.toastr.error("Please Select End Date ", "Error");
      return;
    }
    try {
      var fd = new Date(this.startDate).toDateString();
      var td = new Date(this.endDate).toDateString();
      this.purchaseOrderService.GetSinglePurchaseOrdersReport(this.VID, fd, td).subscribe(
        data => {
          this.report = data;
          if (this.report.length == 0) {
            this.toastr.success("No Record Found", "Success");
            
          }
          var vand = this.report[0].vendor
          this.vendorName = vand.vendorName;
          this.reportFrom = this.report[0].dateFrom;
          this.reportTo = this.report[0].dateTo;
          var total = 0;
          for (var i = 0; i < data.length; i++) {
            var single: SinglePOReport;
            single = data[i];
            total += single.total;
          }
          this.total = total;
          this.toastr.success("Report has been generated successfully", "Success");
        }
      )
    } catch (e) {
      this.toastr.error("Something went wrong", "Error");
    }
    
  }
  print(): void {
    let printContents, popupWin;
    printContents = (document.getElementById('print-section') as HTMLElement).innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Order Detail</title>
          <style>
            body{font-family:Arial!important}
            table{font-family:Arial!important;width:100%!important;max-width:100%!important;border: 1px solid #ddd!important;}
            .checkoutProductImage{width: 55px !important;height: auto !important;margin: 8px !important;vertical-align: middle;}
            table th, table td {vertical-align: middle !important;padding: 10px;border-bottom: 1px solid #ddd!important;text-align:left!important}
            table th{background-color:#fafafa!important}
            a{text-decoration:none!important;}
            .invoice-img-show{display: block;}
          </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  } 
}



// WEBPACK FOOTER //
// ./src/app/order-components/single-po-report/single-po-report.component.ts